import { css } from 'linaria';
import { BadgeProps, Variables } from '../index';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --badge-neutral-color: ${Variables.css.grey3};
            --badge-text-color: ${Variables.css.catapultWhite};
            --badge-orange-color: ${Variables.css.catapultOrange};
        }

        [data-theme='dark'] {
            --badge-neutral-color: ${Variables.css.grey5};
            --badge-text-color: ${Variables.css.catapultBlack};
            --badge-orange-color: ${Variables.css.orange2};
        }
    }
`;

export const root = css`
    display: inline-flex;
    align-items: center;
    gap: ${Variables.css.spacing8};
`;

export const badge = css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

export const button = css`
    appearance: none;
    background: transparent;
    border: 0;
    border-radius: 4px;

    &:focus-visible {
        box-shadow: 0 0 0 4px ${Variables.css.focusRing};
    }

    &[disabled] {
        opacity: 0.5;
    }
`;

export const variants: Record<BadgeProps['variant'], string> = {
    neutral: css`
        background: var(--badge-neutral-color);
    `,
    alert: css`
        background: ${Variables.css.alert};
    `,
    success: css`
        background: ${Variables.css.success};
    `,
    warning: css`
        background: ${Variables.css.warning};
    `,
    information: css`
        background: ${Variables.css.information};
    `,
    'catapult-orange': css`
        background: var(--badge-orange-color);
    `,
};

export const dot = css`
    width: 8px;
    height: 8px;
    border-radius: 10px;
`;

export const counter = css`
    min-width: 16px;
    border-radius: 20px;
    color: var(--badge-text-color);
    padding: 0 ${Variables.css.spacing4};
`;
